import { render, staticRenderFns } from "./uploadVideoDialog.vue?vue&type=template&id=2e6af58c&scoped=true&"
import script from "./uploadVideoDialog.vue?vue&type=script&lang=js&"
export * from "./uploadVideoDialog.vue?vue&type=script&lang=js&"
import style0 from "./uploadVideoDialog.vue?vue&type=style&index=0&id=2e6af58c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6af58c",
  null
  
)

export default component.exports